export const AVAILABLE_LEVELS = [
  { value: 'Level 1', label: 'Level 1' },
  { value: 'Level 2', label: 'Level 2' },
  { value: 'Level 3', label: 'Level 3' },
  { value: 'Level 4', label: 'Level 4' },
  { value: 'Level 5', label: 'Level 5' },
  { value: 'Level 6', label: 'Level 6' },
  { value: 'Level 7', label: 'Level 7' },
  { value: 'Level 8', label: 'Level 8' },
  { value: 'Level 9', label: 'Level 9' },
  { value: 'Level 10', label: 'Level 10' },
  { value: 'Xcel Bronze', label: 'Xcel Bronze' },
  { value: 'Xcel Silver', label: 'Xcel Silver' },
  { value: 'Xcel Gold', label: 'Xcel Gold' },
  { value: 'Xcel Platinum', label: 'Xcel Platinum' },
  { value: 'Xcel Diamond', label: 'Xcel Diamond' },
  { value: 'HOPES', label: 'HOPES' },
  { value: 'Junior Elite', label: 'Junior Elite' },
  { value: 'Senior Elite', label: 'Senior Elite' }
];

export const COMPETITION_STATUSES = {
  draft: { value: 'draft', label: 'Draft', color: 'default' },
  upcoming: { value: 'upcoming', label: 'Upcoming', color: 'info' },
  published: { value: 'published', label: 'Published', color: 'info' },
  registration_open: { value: 'registration_open', label: 'Registration Open', color: 'success' },
  registration_closed: { value: 'registration_closed', label: 'Registration Closed', color: 'primary' },
  in_progress: { value: 'in_progress', label: 'In Progress', color: 'warning' },
  completed: { value: 'completed', label: 'Completed', color: 'default' },
  cancelled: { value: 'cancelled', label: 'Cancelled', color: 'error' }
};

export const DEFAULT_TIME_BLOCKS = [
  { id: 'openStretchStart', label: 'Open Stretch', optional: true },
  { id: 'warmUpStart', label: 'Warm Up', optional: true },
  { id: 'marchInStart', label: 'March In', optional: true },
  { id: 'competitionStart', label: 'Competition Start', optional: true },
  { id: 'competitionEnd', label: 'Competition End', optional: true },
  { id: 'awardsEnd', label: 'Awards', optional: true }
];

export const SESSION_TYPES = [
  'Traditional',
  'Capital Cup',
  'Modified Capital Cup',
  'NCAA Traditional'
];

export const GENDER_OPTIONS = [
  { value: 'M', label: 'Men' },
  { value: 'F', label: 'Women' },
  { value: 'O', label: 'Other' }
];

export const LEVEL_OPTIONS = [
  // Men's Levels - Developmental (no divisions)
  { value: 'L1', label: 'Level 1', gender: 'M', aliases: ['MLEVEL01', '1'], scoring: {
    type: 'Developmental', startValue: '10.0',
    description: 'Introductory level: basic shapes, positions, and fundamental movement patterns',
    deductions: '0.1-0.3 execution; focus on body positions',
    sourceUrl: 'https://usagym.org/men/rules/'
  }},
  { value: 'L2', label: 'Level 2', gender: 'M', aliases: ['MLEVEL02', '2'], scoring: {
    type: 'Developmental', startValue: '10.0',
    description: 'Foundation skills: basic swings, supports, and introductory tumbling',
    deductions: '0.1-0.3 execution; technique emphasis',
    sourceUrl: 'https://usagym.org/men/rules/'
  }},
  // Men's Levels 3-6 - Compulsory with D1/D2 divisions
  { value: '3 D1', label: '3 D1', gender: 'M', aliases: ['M3D1', 'MLEVEL03D1', '3D1'], baseLevel: '3', division: 'D1', scoring: {
    type: 'Compulsory D1', startValue: '10.0',
    description: 'Level 3 Division 1: 9.0 base + 0.9 virtuosity + 0.1 stick bonus',
    deductions: '0.1-0.5 execution; element-specific deductions per routine',
    sourceUrl: 'https://usagym.org/men/rules/'
  }},
  { value: '3 D2', label: '3 D2', gender: 'M', aliases: ['M3D2', 'MLEVEL03D2', '3D2'], baseLevel: '3', division: 'D2', scoring: {
    type: 'Compulsory D2', startValue: '9.0',
    description: 'Level 3 Division 2: 9.0 base only, no virtuosity bonus',
    deductions: '0.1-0.5 execution; element-specific deductions per routine',
    sourceUrl: 'https://usagym.org/men/rules/'
  }},
  { value: '4 D1', label: '4 D1', gender: 'M', aliases: ['M4D1', 'MLEVEL04D1', '4D1'], baseLevel: '4', division: 'D1', scoring: {
    type: 'Compulsory D1', startValue: '10.0',
    description: 'Level 4 Division 1: 9.0 base + 0.9 virtuosity + 0.1 stick bonus',
    deductions: '0.1-0.5 execution; 0.5 falls; element-specific deductions',
    sourceUrl: 'https://usagym.org/men/rules/'
  }},
  { value: '4 D2', label: '4 D2', gender: 'M', aliases: ['M4D2', 'MLEVEL04D2', '4D2'], baseLevel: '4', division: 'D2', scoring: {
    type: 'Compulsory D2', startValue: '9.0',
    description: 'Level 4 Division 2: 9.0 base only, no virtuosity bonus',
    deductions: '0.1-0.5 execution; 0.5 falls; element-specific deductions',
    sourceUrl: 'https://usagym.org/men/rules/'
  }},
  { value: '5 D1', label: '5 D1', gender: 'M', aliases: ['M5D1', 'MLEVEL05D1', '5D1'], baseLevel: '5', division: 'D1', scoring: {
    type: 'Compulsory D1', startValue: '10.0',
    description: 'Level 5 Division 1: 9.0 base + 0.9 virtuosity + 0.1 stick bonus',
    deductions: '0.1-0.5 execution; 0.5 falls; element-specific deductions',
    sourceUrl: 'https://usagym.org/men/rules/'
  }},
  { value: '5 D2', label: '5 D2', gender: 'M', aliases: ['M5D2', 'MLEVEL05D2', '5D2'], baseLevel: '5', division: 'D2', scoring: {
    type: 'Compulsory D2', startValue: '9.0',
    description: 'Level 5 Division 2: 9.0 base only, no virtuosity bonus',
    deductions: '0.1-0.5 execution; 0.5 falls; element-specific deductions',
    sourceUrl: 'https://usagym.org/men/rules/'
  }},
  { value: '6 D1', label: '6 D1', gender: 'M', aliases: ['M6D1', 'MLEVEL06D1', '6D1'], baseLevel: '6', division: 'D1', scoring: {
    type: 'Compulsory D1', startValue: '10.0',
    description: 'Level 6 Division 1: 9.0 base + 0.9 virtuosity + 0.1 stick bonus',
    deductions: '0.1-0.5 execution; 0.5 falls; element-specific deductions',
    sourceUrl: 'https://usagym.org/men/rules/'
  }},
  { value: '6 D2', label: '6 D2', gender: 'M', aliases: ['M6D2', 'MLEVEL06D2', '6D2'], baseLevel: '6', division: 'D2', scoring: {
    type: 'Compulsory D2', startValue: '9.0',
    description: 'Level 6 Division 2: 9.0 base only, no virtuosity bonus',
    deductions: '0.1-0.5 execution; 0.5 falls; element-specific deductions',
    sourceUrl: 'https://usagym.org/men/rules/'
  }},
  { value: '6 JE', label: '6 JE', gender: 'M', aliases: ['MLEVEL06JE', 'M6JE', '6JE'], baseLevel: '6', division: 'JE', scoring: {
    type: 'Junior Elite Qualifier', startValue: '10.0',
    description: 'Level 6 Junior Elite: pathway to elite program',
    deductions: '0.1-0.5 execution; 0.5 falls; element-specific deductions',
    sourceUrl: 'https://usagym.org/men/rules/'
  }},
  // Men's Levels 7-10 - Optional with JN/JE paths
  { value: 'L7', label: 'Level 7', gender: 'M', aliases: ['MLEVEL07JN', 'MLEVEL07', '7'], baseLevel: '7', scoring: {
    type: 'Optional', startValue: '10.0 + D-Score',
    description: 'First optional level: 10.0 base + difficulty. Element group and skill requirements',
    deductions: '0.1-0.5 execution; 0.5 falls; 0.1 stick bonus; connection bonuses available',
    sourceUrl: 'https://usagym.org/men/rules/'
  }},
  { value: '8 JN', label: '8 JN', gender: 'M', aliases: ['MLEVEL08JN', 'M8JN', '8JN'], baseLevel: '8', division: 'JN', scoring: {
    type: 'Optional JN', startValue: '10.0 + D-Score',
    description: 'Level 8 Junior National: standard JO pathway',
    deductions: '0.1-0.5 execution; 0.5 falls; 0.1 stick bonus; connection bonuses available',
    sourceUrl: 'https://usagym.org/men/rules/'
  }},
  { value: '8 JE', label: '8 JE', gender: 'M', aliases: ['MLEVEL08JE', 'M8JE', '8JE'], baseLevel: '8', division: 'JE', scoring: {
    type: 'Optional JE', startValue: '10.0 + D-Score',
    description: 'Level 8 Junior Elite: elite development pathway',
    deductions: '0.1-0.5 execution; 0.5 falls; 0.1 stick bonus; connection bonuses available',
    sourceUrl: 'https://usagym.org/men/rules/'
  }},
  { value: '9 JN', label: '9 JN', gender: 'M', aliases: ['MLEVEL09JN', 'M9JN', '9JN'], baseLevel: '9', division: 'JN', scoring: {
    type: 'Optional JN', startValue: '10.0 + D-Score',
    description: 'Level 9 Junior National: advanced JO pathway',
    deductions: '0.1-0.5 execution; 0.5 falls; 0.1 stick bonus; connection bonuses available',
    sourceUrl: 'https://usagym.org/men/rules/'
  }},
  { value: '9 JE', label: '9 JE', gender: 'M', aliases: ['MLEVEL09JE', 'M9JE', '9JE'], baseLevel: '9', division: 'JE', scoring: {
    type: 'Optional JE', startValue: '10.0 + D-Score',
    description: 'Level 9 Junior Elite: elite development pathway',
    deductions: '0.1-0.5 execution; 0.5 falls; 0.1 stick bonus; connection bonuses available',
    sourceUrl: 'https://usagym.org/men/rules/'
  }},
  { value: '10 JN JR', label: '10 JN JR', gender: 'M', aliases: ['MLEVEL10JNJR', 'M10JNJR'], baseLevel: '10', division: 'JN', ageGroup: 'JR', scoring: {
    type: 'Optional JN Junior', startValue: '10.0 + D-Score',
    description: 'Level 10 Junior National - Junior age division',
    deductions: '0.1-0.5 execution; 0.5 falls; 0.1 stick bonus; connection bonuses available',
    sourceUrl: 'https://usagym.org/men/rules/'
  }},
  { value: '10 JN SR', label: '10 JN SR', gender: 'M', aliases: ['MLEVEL10JNSR', 'M10JNSR'], baseLevel: '10', division: 'JN', ageGroup: 'SR', scoring: {
    type: 'Optional JN Senior', startValue: '10.0 + D-Score',
    description: 'Level 10 Junior National - Senior age division',
    deductions: '0.1-0.5 execution; 0.5 falls; 0.1 stick bonus; connection bonuses available',
    sourceUrl: 'https://usagym.org/men/rules/'
  }},
  { value: '10 JE JR', label: '10 JE JR', gender: 'M', aliases: ['MLEVEL10EJR', 'MLEVEL10JEJR', 'M10EJR'], baseLevel: '10', division: 'JE', ageGroup: 'JR', scoring: {
    type: 'Optional JE Junior', startValue: '10.0 + D-Score',
    description: 'Level 10 Junior Elite - Junior age division',
    deductions: '0.1-0.5 execution; 0.5 falls; 0.1 stick bonus; connection bonuses available',
    sourceUrl: 'https://usagym.org/men/rules/'
  }},
  { value: '10 JE SR', label: '10 JE SR', gender: 'M', aliases: ['MLEVEL10ESR', 'MLEVEL10JESR', 'M10ESR'], baseLevel: '10', division: 'JE', ageGroup: 'SR', scoring: {
    type: 'Optional JE Senior', startValue: '10.0 + D-Score',
    description: 'Level 10 Junior Elite - Senior age division',
    deductions: '0.1-0.5 execution; 0.5 falls; 0.1 stick bonus; connection bonuses available',
    sourceUrl: 'https://usagym.org/men/rules/'
  }},
  { value: 'E', label: 'Elite', gender: 'M', aliases: ['MELITE', 'Junior Elite', 'Senior Elite'], scoring: {
    type: 'Optional (FIG)', startValue: 'D-Score (open)',
    description: 'FIG Code of Points: D-score (difficulty, no base) + E-score (execution from 10.0)',
    deductions: '0.1-0.5+ execution; 0.5 falls; neutral deductions for time/line violations',
    sourceUrl: 'https://www.gymnastics.sport/site/rules/'
  }},
  { value: 'HUGS', label: 'HUGS', gender: 'M', aliases: ['MHUGS'], scoring: {
    type: 'Adaptive', startValue: '10.0',
    description: 'Adaptive gymnastics program: modified requirements based on ability',
    deductions: 'Modified deduction scale based on athlete classification',
    sourceUrl: 'https://usagym.org/men/rules/'
  }},
  { value: 'EXHIB', label: 'Exhibition', gender: 'M', aliases: ['MEXHIB'], scoring: {
    type: 'Exhibition', startValue: 'N/A',
    description: 'Non-competitive demonstration routines',
    deductions: 'No competitive scoring'
  }},

  // Women's Levels
  { value: 'XB', label: 'Bronze', gender: 'F', aliases: ['WBRONZE'], scoring: {
    type: 'Modified Optional', startValue: '10.0',
    description: 'Introductory Xcel: 3-4 skills per event, basic element requirements',
    deductions: '0.05-0.30 execution; up to 0.50 for falls',
    sourceUrl: 'https://usagym.org/women/xcel/'
  }},
  { value: 'XS', label: 'Silver', gender: 'F', aliases: ['WSILVER'], scoring: {
    type: 'Modified Optional', startValue: '10.0', bonusMax: '0.50',
    description: '4-5 skills per event, flexibility in routine construction',
    deductions: '0.05-0.30 execution; up to 0.50 for falls; bonus available',
    sourceUrl: 'https://usagym.org/women/xcel/'
  }},
  { value: 'XG', label: 'Gold', gender: 'F', aliases: ['WGOLD'], scoring: {
    type: 'Optional', startValue: '10.0', bonusMax: '0.50',
    description: '5+ skills per event, specific element group requirements',
    deductions: '0.05-0.30 execution; up to 0.50 for falls; bonus available',
    sourceUrl: 'https://usagym.org/women/xcel/'
  }},
  { value: 'XP', label: 'Platinum', gender: 'F', aliases: ['WPLATINUM'], scoring: {
    type: 'Optional', startValue: '10.0', bonusMax: '0.50',
    description: 'Advanced Xcel: higher skill requirements, connection bonuses',
    deductions: '0.05-0.30 execution; up to 0.50 for falls; bonus available',
    sourceUrl: 'https://usagym.org/women/xcel/'
  }},
  { value: 'XD', label: 'Diamond', gender: 'F', aliases: ['WDIAMOND'], scoring: {
    type: 'Optional', startValue: '10.0', bonusMax: '0.50',
    description: 'Highest Xcel division: complex requirements approaching JO Level 6',
    deductions: '0.05-0.30 execution; up to 0.50 for falls; bonus available',
    sourceUrl: 'https://usagym.org/women/xcel/'
  }},
  { value: 'L1', label: 'Level 1', gender: 'F', aliases: ['WLEVEL01', '1'], scoring: {
    type: 'Compulsory', startValue: '10.0',
    description: 'Introductory JO: basic positions, shapes, and fundamental skills',
    deductions: '0.05-0.20 execution; focus on body positions and alignment',
    sourceUrl: 'https://usagym.org/women/rules/'
  }},
  { value: 'L2', label: 'Level 2', gender: 'F', aliases: ['WLEVEL02', '2'], scoring: {
    type: 'Compulsory', startValue: '10.0',
    description: 'Foundation skills: cartwheels, handstands, basic swing skills',
    deductions: '0.05-0.30 execution; technique and form emphasis',
    sourceUrl: 'https://usagym.org/women/rules/'
  }},
  { value: 'L3', label: 'Level 3', gender: 'F', aliases: ['WLEVEL03', '3'], scoring: {
    type: 'Compulsory', startValue: '10.0',
    description: 'Developing skills: round-offs, back walkovers, kips introduced',
    deductions: '0.05-0.30 execution; up to 0.50 for falls',
    sourceUrl: 'https://usagym.org/women/rules/'
  }},
  { value: 'L4', label: 'Level 4', gender: 'F', aliases: ['WLEVEL04', '4'], scoring: {
    type: 'Compulsory', startValue: '10.0',
    description: 'Intermediate compulsory: back handsprings, clear hip circles',
    deductions: '0.05-0.30 execution; up to 0.50 for falls',
    sourceUrl: 'https://usagym.org/women/rules/'
  }},
  { value: 'L5', label: 'Level 5', gender: 'F', aliases: ['WLEVEL05', '5'], scoring: {
    type: 'Compulsory', startValue: '10.0',
    description: 'Advanced compulsory: front/back tucks, giants, complex combinations',
    deductions: '0.05-0.30 execution; up to 0.50 for falls',
    sourceUrl: 'https://usagym.org/women/rules/'
  }},
  { value: 'L6', label: 'Level 6', gender: 'F', aliases: ['WLEVEL06', '6'], scoring: {
    type: 'Optional', startValue: '10.0',
    description: 'First optional level: athlete-designed routines, specific requirements per event',
    deductions: '0.05-0.30 execution; up to 0.50 for falls; SR deductions for missing requirements',
    sourceUrl: 'https://usagym.org/women/development/optionals/'
  }},
  { value: 'L7', label: 'Level 7', gender: 'F', aliases: ['WLEVEL07', '7'], scoring: {
    type: 'Optional', startValue: '10.0',
    description: 'Intermediate optional: higher skill requirements, acro series on beam',
    deductions: '0.05-0.30 execution; up to 0.50 for falls; SR deductions apply',
    sourceUrl: 'https://usagym.org/women/development/optionals/'
  }},
  { value: 'L8', label: 'Level 8', gender: 'F', aliases: ['WLEVEL08', '8'], scoring: {
    type: 'Optional', startValue: '10.0',
    description: 'Advanced optional: "B" value skills required, higher combinations',
    deductions: '0.05-0.30 execution; up to 0.50 for falls; SR and composition deductions',
    sourceUrl: 'https://usagym.org/women/development/optionals/'
  }},
  { value: 'L9', label: 'Level 9', gender: 'F', aliases: ['WLEVEL09', '9'], scoring: {
    type: 'Optional', startValue: '10.0',
    description: 'Pre-elite: "C" value skills, difficulty requirements approach elite',
    deductions: '0.05-0.50 execution; up to 0.50 for falls; D-score deductions for missing difficulty',
    sourceUrl: 'https://usagym.org/women/development/optionals/'
  }},
  { value: 'L10', label: 'Level 10', gender: 'F', aliases: ['WLEVEL10', '10'], scoring: {
    type: 'Optional', startValue: '10.0',
    description: 'Highest JO level: elite-level requirements, "D" value skills expected',
    deductions: '0.05-0.50 execution; up to 0.50 for falls; full D-score/E-score evaluation',
    sourceUrl: 'https://usagym.org/women/development/optionals/'
  }},
  { value: 'HP', label: 'Elite', gender: 'F', aliases: ['WELITE', 'Junior Elite', 'Senior Elite'], scoring: {
    type: 'Optional (FIG)', startValue: 'Open D-Score',
    description: 'FIG Code of Points: D-score (difficulty) + E-score (execution, max 10.0)',
    deductions: '0.10-0.50+ execution; 0.50 falls; neutral deductions for time/line violations',
    sourceUrl: 'https://www.gymnastics.sport/site/rules/'
  }},
  { value: 'HUGS', label: 'HUGS', gender: 'F', aliases: ['WHUGS'], scoring: {
    type: 'Adaptive', startValue: '10.0',
    description: 'Adaptive gymnastics program: modified requirements based on ability',
    deductions: 'Modified deduction scale based on athlete classification',
    sourceUrl: 'https://usagym.org/women/rules/'
  }},
  { value: 'EXHIB', label: 'Exhibition', gender: 'F', aliases: ['WEXHIB'], scoring: {
    type: 'Exhibition', startValue: 'N/A',
    description: 'Non-competitive demonstration routines',
    deductions: 'No competitive scoring'
  }},

  // Rhythmic Levels
  { value: 'RSS', label: 'SuperStars', gender: 'R', aliases: ['RSS'] },
  { value: 'RC', label: 'Copper', gender: 'R', aliases: ['RCOPPER'] },
  { value: 'RB', label: 'Bronze', gender: 'R', aliases: ['RBRONZE'] },
  { value: 'RS', label: 'Silver', gender: 'R', aliases: ['RSILVER'] },
  { value: 'RG', label: 'Gold', gender: 'R', aliases: ['RGOLD'] },
  { value: 'RP', label: 'Platinum', gender: 'R', aliases: ['RPLATINUM'] },
  { value: 'RD', label: 'Diamond', gender: 'R', aliases: ['RDIAMOND'] },
  { value: 'L1', label: 'Level 1', gender: 'R', aliases: ['RLEVEL01'] },
  { value: 'L2', label: 'Level 2', gender: 'R', aliases: ['RLEVEL02'] },
  { value: 'L3', label: 'Level 3', gender: 'R', aliases: ['RLEVEL03'] },
  { value: 'L4', label: 'Level 4', gender: 'R', aliases: ['RLEVEL04'] },
  { value: 'L5', label: 'Level 5', gender: 'R', aliases: ['RLEVEL05'] },
  { value: 'L6', label: 'Level 6', gender: 'R', aliases: ['RLEVEL06'] },
  { value: 'L7', label: 'Level 7', gender: 'R', aliases: ['RLEVEL07'] },
  { value: 'L8', label: 'Level 8', gender: 'R', aliases: ['RLEVEL08'] },
  { value: 'L9', label: 'Level 9', gender: 'R', aliases: ['RLEVEL09'] },
  { value: 'L10', label: 'Level 10', gender: 'R', aliases: ['RLEVEL10'] },
  { value: 'E', label: 'Elite', gender: 'R', aliases: ['RELITE', 'Junior Elite', 'Senior Elite'] },
  { value: 'HUGS', label: 'HUGS', gender: 'R', aliases: ['RHUGS'] },
  { value: 'EXHIB', label: 'Exhibition', gender: 'R', aliases: ['REXHIBI'] },
];

export const DEFAULT_MENS_ROTATION = {
  id: "2",
  eventId: "2", 
  name: "Men's Olympic Order",
  numByes: 0,
  numSquads: 6,
  squadAssignments: [
    "123456",
    "234561",
    "345612",
    "456123",
    "561234",
    "612345"
  ]
};

export const MENS_APPARATUS = [
  { id: 'FX', name: 'Floor Exercise', abbrev: 'FX' },
  { id: 'PH', name: 'Pommel Horse', abbrev: 'PH' },
  { id: 'SR', name: 'Still Rings', abbrev: 'SR' },
  { id: 'VT', name: 'Vault', abbrev: 'VT' },
  { id: 'PB', name: 'Parallel Bars', abbrev: 'PB' },
  { id: 'HB', name: 'High Bar', abbrev: 'HB' }
];

export const WOMENS_APPARATUS = [
  { id: 'VT', name: 'Vault', abbrev: 'VT' },
  { id: 'UB', name: 'Uneven Bars', abbrev: 'UB' },
  { id: 'BB', name: 'Balance Beam', abbrev: 'BB' },
  { id: 'FX', name: 'Floor Exercise', abbrev: 'FX' }
];

export const DEFAULT_WOMENS_ROTATION = {
  id: "1",
  eventId: "1", 
  name: "Women's Olympic Order",
  numByes: 0,
  numSquads: 4,
  squadAssignments: [
    "1234",
    "2341",
    "3412",
    "4123"
  ]
};

export const getStatusLabel = (status) => {
  const normalizedStatus = status?.toLowerCase();
  return COMPETITION_STATUSES[normalizedStatus]?.label || status;
};

export const getStatusColor = (status) => {
  const normalizedStatus = status?.toLowerCase();
  return COMPETITION_STATUSES[normalizedStatus]?.color || 'default';
};

export const ensureCompetitionRotations = (competition) => {
  if (!competition.rotations || competition.rotations.length === 0) {
    return {
      ...competition,
      rotations: [DEFAULT_MENS_ROTATION, DEFAULT_WOMENS_ROTATION]
    };
  }
  return competition;
};
